import { Component, Input, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { ValueName } from "@app/definitions/types"
import { dateDisplay } from "@app/helpers"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import {
	CheckboxesGenComponent,
	SpinOrContent,
} from "@app/utils/utils.component"
import { NgxChartsModule } from "@swimlane/ngx-charts"

@Component({
	selector: "app-test-graph",
	imports: [
		COMMON_IMPORTS,
		CheckboxesGenComponent,
		SpinOrContent,
		LangValPipe,
		NgxChartsModule,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		@if (testscales?.length) {
			<div>
				<app-checkboxes-gen
					[fields]="testscales"
					[obj]="obj"
					title="testscales"
					(onChange)="onChange($event)"
				/>
			</div>
			<app-spin-or-content [isSpin]="isLoading">
				@if (results?.length) {
					<div style="direction: ltr; height: 500px">
						<ngx-charts-line-chart
							[results]="results"
							[view]="[700, 400]"
							[xAxis]="true"
							[yAxis]="true"
							[legend]="true"
							[legendTitle]="'columns' | langVal"
						/>
					</div>
				}
			</app-spin-or-content>
		}
	`,
})
export class TestGraphComponent extends Modalable {
	@Input() test_id: number
	@Input() patient_id: number
	testscale_id: number
	obj: any = {}

	isLoading: boolean = false
	testscales: ValueName[] = []
	results: any[] = []

	async ngOnInit() {
		this.testscales = (
			await this.apiService.post("get_testscales", {
				test_id: this.test_id,
			})
		).map(({ id, name }) => ({ value: id, name }))

		this.obj = this.testscales.reduce(
			(prev, { value }) => ({ ...prev, [value]: false }),
			{}
		)

		if (this.testscales.length) {
			this.obj[this.testscales[0].value] = true
			this.onChange(this.obj)
		}
	}
	async onChange(newObj: any) {
		this.obj = newObj
		this.isLoading = true
		console.log(newObj)

		const actives = Object.keys(newObj).filter((value) => newObj[value])

		const res: any = await this.apiService.post("get_test_graph_scores", {
			test_id: this.test_id,
			patient_id: this.patient_id,
			testscale_ids: actives,
		})

		this.results = actives.map((id) => ({
			name: this.testscales.find(({ value }) => value == id)?.name,
			series: res
				.filter(({ testscale_id }) => testscale_id == id)
				.map(({ created_at, score }) => ({
					name: dateDisplay(created_at),
					value: score,
				})),
		}))

		this.isLoading = false
	}
}
